import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { createAgreementAppService } from "./service";
import { UseCreateAgreementAppMutationOptions } from "./types";
import { AgreementApp } from "@modules/agreementApps/types";
import { AgreementAppFormValues } from "@modules/agreementApps/validations";
import { api } from "@api/api";

export function useCreateAgreementAppMutation(
  options?: UseCreateAgreementAppMutationOptions
) {
  const navigate = useNavigate();
  const { open } = useNotification();

  return useMutation<AgreementApp, ApiError, AgreementAppFormValues>({
    mutationFn: createAgreementAppService,
    onSuccess: (agreement: AgreementApp) => {
      open?.({
        type: "success",
        message: "App Criado com sucesso",
      });

      navigate(`/agreement-apps/edit/${agreement.id}`);
      api.post(`/v1/agreement_app_admin/${agreement.id}/build/`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
